module.exports = __webpack_public_path__ + "img/screenshot4.d8c3ff0d.png";